/**
 * Enables pre checkout blocker for EORI collection
 */
export const ENABLE_XP_PRE_CHECKOUT_RETAILER_EORI_COLLECTION_230912 = 'ENABLE_XP_PRE_CHECKOUT_RETAILER_EORI_COLLECTION_230912';
